import { createSelector } from '@ngrx/store';

import { selectPlanWatch } from '@core/store/plan-edit/plan-edit.selectors';
import { planKpisView } from '@core/store/plan-edit/plan-edit.state';
import { selectPlan } from '@core/store/plan/plan.selectors';

type KpisView = ReturnType<typeof planKpisView>;

/** The KPIs the plan in view shows: a live session's replace the stored plan's. */
export const selectPlanKpisInView = createSelector(
  selectPlanWatch,
  selectPlan,
  (watch, plan): KpisView => planKpisView(watch, plan?.id ?? null, plan?.kpis)
);

/** Every watch patch rebuilds the view; only new KPIs or a new mode should rebuild the tiles. */
export const sameKpisView = (a: KpisView, b: KpisView): boolean =>
  a.kpis === b.kpis && a.mode === b.mode;
